import axios from 'axios';
import { url } from 'utils/urls';

const withCredentials = true;

// "/v1/sites/:siteUUID/embeds/content" - create embed with content for site
export const createEmbed = (siteUUID, data) => {
    const headers = {
        "Content-Type": "application/json",
        'Accept': 'application/json',
    };
    return axios.post(`${url.sites.base}/${siteUUID}/embeds/content`, JSON.stringify(data), { headers, withCredentials })
};

// "/v1/sites/:siteUUID/embeds/:embedUUID/content" - update embed with content for site
export const updateEmbed = (siteUUID, embedUUID, data) => {
    const headers = {
        "Content-Type": "application/json",
        'Accept': 'application/json',
    };
    return axios.put(`${url.sites.base}/${siteUUID}/embeds/${embedUUID}/content`, data, { headers, withCredentials })
};

export const deleteEmbedByUUID = embedUUID => axios.delete(`${url.embeds.base}/${embedUUID}`, { withCredentials });

// "/v1/accounts/:accountUUID/embeds" - get all embeds for account - embed library page
export const getClientEmbedsData = accountUUID => axios.get(`${url.accounts.base}/${accountUUID}/embeds/content`, { withCredentials });

// "/v1/embeds/:embedUUID/content" - get embed details with content, when you click edit on embed
export const getEmbedByUUID = embedUUID => axios.get(`${url.embeds.base}/${embedUUID}/sites/content?withAnalytics=false`, { withCredentials });

export const getEmbedAnalyticsByUUID = embedUUID => axios.get(`${url.embeds.base}/${embedUUID}/sites/content?withAnalytics=true`, { withCredentials });

// route => /v1/embeds/:embedUUID/embedcode/
// url values => :embedUUID - UUID of the embed
// query params => siteUUID - UUID of the site, version - VERSION_4_0.
export const requestEmbedCode = (siteUUID, embedUUID) => axios.get(`${url.embeds.base}/${embedUUID}/embedcode/?siteUUID=${siteUUID}&version=VERSION_4_0`, { withCredentials });


//Retrieve image resources from respective APIs:

//Cancellation tokens for image retrieval functions

const shutterStockCancelToken = axios.CancelToken;
const unsplashCancelToken = axios.CancelToken;
const giphyCancelToken = axios.CancelToken;
const userImagesCancelToken = axios.CancelToken;

export let shutterStockCancel;
export let unsplashCancel;
export let giphyCancel;
export let userImagesCancel


//ShutterStock:

export const queryShutterStock = (query, page) => {
    return axios.get(`${url.shutterStock.search}&query=${query}&page=${page}`, 
    { headers: url.shutterStock.headers, 
      cancelToken: new shutterStockCancelToken(function executor(c){shutterStockCancel=c; })});
};


//Unsplash:

export const queryUnsplash = (query, page) => {
    return axios.get(`${url.unsplash.search}&query=${query}&page=${page}`, 
    { headers: url.unsplash.headers, 
      cancelToken: new unsplashCancelToken(function executor(c){unsplashCancel=c; })});
};


//Giphy:

export const queryGiphy = (query, page) => {
    return axios.get(`${url.giphy.search}${query}&offset=${(page-1)*40}`, 
    { cancelToken: new giphyCancelToken(function executor(c){giphyCancel=c;} )});
};


//User Images:

export const queryUserImages = (UUID) => {
    return axios.get(`${url.accounts.base}/${UUID}/images`, 
    { withCredentials: true, 
      cancelToken: new userImagesCancelToken(function executor(c){userImagesCancel=c;} )});
};

//Default Query

export const defaultQuery = 'nyc';


//Retrieve page resources such as title, description and image:

//Retrieve Page Resource:

export const retrievePageResource = (pageUrl) => {
    return axios.get(`${url.getPageResource}?url=${pageUrl}`)
}
